import { Button, Input, Select } from 'antd';
import './conteudo-ministrado-form.styles.scss';
import useConteudoMinistradoForm from './use-conteudo-ministrado-form.hook';
import {
  conteudoMinistradoDataStore
} from '../../../../../../../store/lancamento-aula/step-1/conteudo-ministrado-data.store';
import { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface ConteudoMinistradoFormProps {
  submitForm: (event: FormEvent<HTMLFormElement>) => void;
  buttonLabel: string;
  formIsDisabled?: boolean;
  disableSubmitButton?: boolean;
  onAulaNaoOcorrida?: () => void;
}

export default function ConteudoMinistradoForm({
  submitForm,
  buttonLabel,
  formIsDisabled,
  disableSubmitButton,
  onAulaNaoOcorrida
}: ConteudoMinistradoFormProps) {
  const { t } = useTranslation('gestao_de_aulas');
  const {
    submitButtonDisabled,
    tipoConteudoMinistrado
  } = useConteudoMinistradoForm();

  const { conteudoMinistradoData, updateConteudoMinistradoData } =
    conteudoMinistradoDataStore();

  return (
    <form
      onSubmit={(event) => submitForm(event)}
      className="conteudo-ministrado-form-wrapper"
    >
      <div className="conteudo-ministrado-form-wrapper__text-field-container">
        <label className="text-field-container__label">
          {t('gestao_de_aulas:contentType')}
        </label>
        <Select
          disabled={formIsDisabled}
          onChange={(event) => updateConteudoMinistradoData(event, 'tipo')}
          rootClassName="text-field-container__input"
          defaultValue={conteudoMinistradoData.tipo}
          value={conteudoMinistradoData.tipo}
          size="large"
          options={tipoConteudoMinistrado}
        />
      </div>

      <div className="conteudo-ministrado-form-wrapper__text-field-container">
        <label className="text-field-container__label">
          {t('gestao_de_aulas:content')}
        </label>
        <Input
          disabled={formIsDisabled}
          onChange={(event) =>
            updateConteudoMinistradoData(event.target.value, 'conteudoDescricao')
          }
          rootClassName="text-field-container__input"
          size="large"
          defaultValue={conteudoMinistradoData.conteudoDescricao}
          value={conteudoMinistradoData.conteudoDescricao}
        />
      </div>

      <div className="conteudo-ministrado-form-wrapper__text-field-container">
        <label className="text-field-container__label">
          {t('gestao_de_aulas:description')}
        </label>
        <Input
          disabled={formIsDisabled}
          onChange={(event) =>
            updateConteudoMinistradoData(event.target.value, 'descricao')}
          rootClassName="text-field-container__input"
          size="large"
          defaultValue={conteudoMinistradoData.descricao}
          value={conteudoMinistradoData.descricao}
          placeholder={t('gestao_de_aulas:contentDescriptionPlaceholder')}
        />
      </div>

      <div className="conteudo-ministrado-wrapper__buttons">
        {onAulaNaoOcorrida && (
          <Button
            disabled={formIsDisabled || disableSubmitButton}
            htmlType="button"
            className="button-danger"
            onClick={onAulaNaoOcorrida}
          >
            {t('gestao_de_aulas:lessonNotOccurredAction')}
          </Button>
        )}
        <Button
          disabled={submitButtonDisabled || formIsDisabled || disableSubmitButton}
          htmlType="submit"
          className="button-primary"
        >
          {buttonLabel}
        </Button>
      </div>
      {disableSubmitButton && (
        <small className="conteudo-ministrado-wrapper__hint">
          {t('gestao_de_aulas:contentAlreadyRegisteredHint')}
        </small>
      )}
    </form>
  );
}
